import styled from 'styled-components';

import Breakpoints from '../../design-utils/breakpoints';

export const CreateBundleContainer = styled.div.attrs<{
  hasProductSelector?: boolean;
  hasDelivery?: boolean;
  hasSizes?: boolean;
  isScrollingUp?: boolean;
  shouldShowControls?: boolean;
  pid?: string;
  vid?: string;
}>(({ hasProductSelector, isScrollingUp, pid, vid }) => ({
  className: `bundle-container p_${pid} pv_${vid} ${
    hasProductSelector ? 'with-product-selector' : ''
  } ${isScrollingUp ? 'is-scrolling-up' : ''}`,
}))`
  padding: 2rem;
  padding-bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  .awt-filters-container {
    margin: 2rem auto;
  }
  main {
    margin: 0 auto;
    width: 100%;
    margin: 0 auto;
    display: grid;
    flex: 1 1 0;
    grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
    grid-auto-rows: min-content;
    overflow-y: auto;
    scroll-behavior: smooth;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
    row-gap: 4rem;
  }

  &.is-scrolling-up {
    @media screen and (max-width: ${Breakpoints.md}) {
      main {
        padding: 0;
        margin: 0;
      }
    }
  }

  header {
    height: 120px;
    @media screen and (max-width: ${Breakpoints.md}) {
      height: 100px;
    }
  }

  footer {
    @media screen and (max-width: ${Breakpoints.md}) {
      height: ${({
        hasProductSelector,
        shouldShowControls,
        hasDelivery,
        hasSizes,
      }) => {
        const hasAll = hasDelivery && hasSizes;
        let footerHeight = 'var(--awt-footer-height, 80px)';

        if (hasProductSelector && shouldShowControls) {
          if (hasDelivery) {
            footerHeight =
              'var(--awt-footer-height-delivery-and-controls, 140px)';
          }

          if (hasSizes) {
            footerHeight = 'var(--awt-footer-height-sizes-and-controls, 119px)';
          }

          if (hasAll) {
            footerHeight = 'var(--awt-footer-height-all-and-controls, 202px)';
          }
        }

        if (hasProductSelector && !shouldShowControls) {
          if (hasDelivery || hasSizes) {
            footerHeight = 'var(--awt-footer-height-no-controls, 106px)';
          }
        }

        return footerHeight;
      }};
    }
    height: var(--awt-footer-height, 80px);
    justify-self: flex-end;
  }
`;

export const CreateBundleFooter = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 1px solid #ccc;
  background-color: #fff;
  min-height: 80px;
  flex: 1 0 80px;
  justify-self: flex-end;
  width: 100vw;
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const CreateBundleButtonInfo = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
`;
